/* unplugin-vue-components disabled */import script from "./ModuleList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModuleList.vue?vue&type=script&lang=ts&setup=true"

import "./ModuleList.vue?vue&type=style&index=0&id=211fe559&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-211fe559"]])

export default __exports__